// extracted by mini-css-extract-plugin
export var cmtPill = "styles-module--cmt-pill--f2f20";
export var cmtPillSmall = "styles-module--cmt-pill--small--ff282";
export var cmtPillVariantPrimary = "styles-module--cmt-pill--variant-primary--d5f50";
export var cmtPillVariantSecondary = "styles-module--cmt-pill--variant-secondary--eebf9";
export var cmtPillVariantTertiary = "styles-module--cmt-pill--variant-tertiary--fa14b";
export var cmtPill__inner = "styles-module--cmt-pill__inner--50f28";
export var cmtPill__label = "styles-module--cmt-pill__label--7f005";